import { FC } from "react";
import styles from "./loading.module.scss";
import { LoadingIcon } from "./LoadingIcon/LoadingIcon";

interface Props {
  dotStyle?: string;
  size?: string;
}

export const Loading: FC<Props> = ({ dotStyle = "", size = "" }) => {
  const getColor = (color) => {
    switch (color) {
      case "BlueOnWhite":
        return { dotColor: "blue", backgroundColor: "white" };
      case "BlueOnGrey":
        return { dotColor: "blue", backgroundColor: "grey" };
      case "BlueOnLightBlue":
        return { dotColor: "blue", backgroundColor: "light-blue" };
      case "WhiteOnGradientBlue":
        return { dotColor: "white", backgroundColor: "gradient-blue" };
      case "BlueOnTransparent":
        return { dotColor: "blue", backgroundColor: "transparent" };
      default:
        return { dotColor: "blue", backgroundColor: "white" };
    }
  };

  const getSize = (dotSize: string) => {
    switch (dotSize) {
      case "small":
        return "small";
      case "medium":
        return "medium";
      case "large":
        return "large";
      default:
        return "medium";
    }
  };

  const dotSize = getSize(size);
  const { dotColor, backgroundColor } = getColor(dotStyle);

  const className = {
    "light-blue": styles.iconLightBlueBackground,
    "gradient-blue": styles.iconGradientBlueBackground,
    white: styles.iconWhiteBackground,
    grey: styles.iconGreyBackground,
    transparent: styles.iconTransparentBackground,
  }[backgroundColor];

  return (
    <div className={styles.loadingContainer}>
      <div className={className}>
        <LoadingIcon style={dotColor} size={dotSize} />
      </div>
    </div>
  );
};
